<template>
  <div v-if="entreeID">
    <b-overlay :show="showOverlay" class="b-overlay-app" rounded="sm">
      <!--      <h2>Formulaire</h2>-->
      <form id="myForm">

        <div class="form-group categorisation">
          <h3>Motif</h3>
          <p>{{ motif.libelle }}</p>
          <div style="display: none;">
            <label for="categorie">Categorie: </label>
            <input id="categorie" class="form-control" name="categorie" readonly type="text" v-model="categorieID"><br>

            <label for="type">Type: </label>
            <input id="type" class="form-control" name="type" readonly type="text" v-model="typeID"><br>

            <label for="nature">Nature: </label>
            <input id="nature" class="form-control" name="nature" readonly type="text" v-model="natureID"><br>

            <label for="motif">Motif: </label>
            <input id="motif" class="form-control" name="motif" readonly type="text" v-model="motifID"><br>
          </div>
        </div>

        <div class="form-group">
          <h3>Adresse</h3>
          <p>{{ entreeInfos.numeroRue }} {{ entreeInfos.rue }}</p>
          <label for="entree" hidden>Entree: </label>
          <input id="entree" class="form-control" hidden name="entree" readonly type="text" v-model="entreeID">

          <h3>Localisation</h3>
          <label for="logementObject">Logement: </label>

          <b-form-select v-model="selectedLogement" :options="optionLogements" class="form-control"
            name="logementObject" @change="onLogementChange()" :disabled=isGardien>
          </b-form-select>

          <label v-if="entreeEtageMax != entreeEtageMin && !isFromSollicitation && partieCommuneSelected"
            for="etage">Etage: </label>
          <select v-if="entreeEtageMax != entreeEtageMin && !isFromSollicitation && partieCommuneSelected" id="etage"
            v-model="selectedEtage" class="form-control" name="etage">
            <option :value="null"></option>
            <option v-for="etage in (entreeEtageMax - (entreeEtageMin -1))" :key="etage"
              :value="etage + (entreeEtageMin -1)">Etage N°{{ etage + (entreeEtageMin - 1) }}
            </option>
          </select>

          <div v-show="locataireMustBeReclamant">
            <div class="row m-1">
              <span class="pr-5">Le locataire est le réclamant? </span>
              <toggle-button v-model="createAsLocataire" :font-size="15" :height="20"
                :labels="{unchecked: 'non', checked: 'oui'}" :width="70" />
            </div>
            <div class="row m-1">
              <small v-if="!createAsLocataire">Vous serez considéré comme le réclamant, le locataire ne pourra pas
                suivre cette sollicitation</small>
              <small v-else>Vous vous substituez au locataire, vous ne verrez pas cette sollicitation dans "Mes
                sollicitations créées"</small>
            </div>
          </div>

        </div>

        <div v-if="motif.aide != null">
          <hr>
          <a v-if="!displayHelp" class="btn btn-sm btn-primary py-0 mb-1" @click="displayHelp = true"><i
              class="fas fa-info"></i></a>
          <a v-if="displayHelp" class="btn btn-sm btn-danger py-0 mb-1" @click="displayHelp = false"><i
              class="fas fa-times"></i></a>
          <p v-if="displayHelp" class="bg-light rounded py-2">
            Aide : {{ motif.aide }}
          </p>
        </div>


        <div class="form-group shadow-textarea">
          <h3>Détail de la réclamation</h3>
          <textarea id="details" class="form-control z-depth-1" name="details" placeholder="Détaillez la réclamation..." v-model="description"
            rows="3"></textarea>
        </div>

        <div v-if="motif && motif.association != null" class="col-12 my-1 row">
          <hr class="col-11">
          <div v-for="(value,key) in motif.association" :key="key" class="col-12 row px-0">
            <p class="col my-1 align-self-start">{{ key }} ?</p>
            <div class="col my-1 align-self-end">
              <toggle-button v-model="secondesLigne[value]" :font-size="15" :height="20"
                :labels="{unchecked: 'Non', checked: 'Oui'}" :width="70" />
            </div>
          </div>
          <hr class="col-11">
        </div>

        <button class="btn btn-success" @click="createSollicitation">Envoyer</button>

      </form>
    </b-overlay>

  </div>
</template>

<script>

import toast from "../../js/toast";

export default {
  name: "Formulaire",
  props: {
    paramsExists: Boolean
  },
  data() {
    return {
      selectedLogement: null,
      showOverlay: false,
      selectedEtage: null,
      displayHelp: false,
      secondesLigne: [],
      createAsLocataire: true,
      description: 'test',
    }
  },
  methods: {
    showToast(toastType) {
      toast.showToast(toastType)
    },
    onLogementChange() {
      this.selectedEtage = null;
    },
    async createSollicitation(e) {
      // Créé une sollicitation dans la base de données.
      // La création d'une sollicitation se fait avec une provenance "AI" (Application Interne) et un utilisateur "Application AMSOM Habitat"
      // Si l'utilisateur est le sollicitant, son code TIERS sera renseigné dans le système en tant que sollicitant et le type réclamant sera T (pour Tiers)
      // Si le locataire est le sollicitant, son code contrat sera renseigné et le type réclamant sera L (code utilisé pour les contrats)

      e.preventDefault()

      let object = {};

      // Suppression des sollicitations précédemment chargées pour raffraîchir la liste lors de la prochaine consultation
      // this.$store.dispatch('sollicitations/clearSollicitations')


      let myForm = document.getElementById('myForm');
      let formData = new FormData(myForm);

      // Si l'utilisateur connecté possède un PEC dans la base de données
      if (this.codePec)
        formData.append("pecsaisipar", this.codePec);

      // Un module a été sélectionné par l'utilisateur
      if (!this.partieCommuneSelected) {
        formData.append('logement', this.selectedLogement.id);
        this.selectedEtage = null;
      }

      if (this.locataireMustBeReclamant && this.createAsLocataire) // Le locataire peut être sélectionné et la coche "Locataire sollicitant" est checkée
      {
        // Cas du locataire désigné comme étant le sollicitant => L + code contrat loc,
        formData.append("typeReclamant", 'L');
        formData.append("reclamant", this.selectedLogement.idContrat);
      } else {
        // Cas de l'utilisateur désigné comme étant le sollicitant
        formData.append("typeReclamant", 'T');
        formData.append("reclamant", this.codeTiers);
      }

      //formData.append("provenance", this.$store.getters['user/'].getTypeUser()); // Supprimé, provenance = "Gardien" est possible mais pas "Gestionnaire_gardien" par exemple 

      if (this.isFromSollicitation) {
        formData.append("fromSollicitation", this.$route.params.sollicitation);
      }

      formData.forEach((value, key) => {
        object[key] = value
      });

      let json = JSON.stringify(object);

      this.showOverlay = true
      let success = await this.$store.dispatch('sollicitations/createSollicitation', json)

      if (success) {
        toast.showToast('success', 'La sollicitation a bien été enregistrée')
        let toRedirect = success

        for (const [key, value] of Object.entries(this.secondesLigne)) {
          if (value) {
            toast.showToast('info', 'Création de la ligne pour le ' + key, 3000)
            object["fromSollicitation"] = success
            let newMotif = this.$store.getters['motifs/getMotifById'](key)
            if (newMotif) {
              object['motif'] = newMotif.id
              object['nature'] = newMotif.nature
              let newNature = this.$store.getters['natures/getNatureById'](newMotif.nature)
              object['type'] = newNature.type
              let newType = this.$store.getters['types/getTypeById'](newNature.type)
              object['categorie'] = newType.categorie
              json = JSON.stringify(object)
              success = await this.$store.dispatch('sollicitations/createSollicitation', json)
              if (success) {
                toast.showToast('success', 'La ligne pour le ' + key + ' a bien été enregistrée')
              } else {
                toast.showToast('error', 'La ligne pour le ' + key + ' n\'a pas pu être crée', 3000)
              }
            }
          }
        }

        toast.showToast('success', "Redirection en cours...");
        
        this.showOverlay = false
        this.$router.push({name: 'fichesuivi', params: {id: toRedirect}})

        this.showOverlay = false
      } else {
        this.showOverlay = false
        toast.showToast('error', 'Echec de l\'envoi essayez à nouveau')
      }
    }
  },
  computed: {
    motif() {
      return this.$store.getters['motifs/getMotifById'](this.$store.getters['motifs/selectedMotif'])
    },
    entreeID() {
      return this.$store.getters['entrees/selectedEntree'];
    },
    categorieID() {
      return this.$store.getters['categories/selectedCategory']
    },
    typeID() {
      return this.$store.getters['types/selectedType']
    },
    natureID() {
      return this.$store.getters['natures/selectedNature']
    },
    motifID() {
      return this.$store.getters['motifs/selectedMotif']
    },
    entreeInfos() {
      return this.$store.getters['entrees/getEntreeByID'](this.$store.getters['entrees/selectedEntree'])[0];
    },
    entreeEtageMin() {
      return this.entreeInfos.etageMin;
    },
    entreeEtageMax() {
      return this.entreeInfos.etageMax;
    },
    entreeListEtages() {
      // Retourne une liste des distincts étages dans this.logements
      return [...new Set(this.logements.map(logement => {
        return logement.etage;
      }))];
    },
    logements() {
      return this.$store.getters['logements/getLogementsByEntree'](this.$store.getters['entrees/selectedEntree'])
    },
    optionLogements() {

      let options = [];
      options.push({value: null, text: "Concerne les parties communes de l'entrée"}); // Première option


      if (this.entreeListEtages.length > 1) {
        this.entreeListEtages.slice().sort().forEach(etage => { // Pour chaque étage
          let struct = ({
            label: "Niveau " + etage.replace('0', 'RDC'),
            options: this.logements.filter(l => l.etage == etage).map(l => {
              return ({
                value: l,
                text: l.libelleModule
              })
            })
          });
          options.push(struct);
        });
      } else {
        this.logements.forEach(l => {
          options.push({
            value: l, text: l.libelleModule
          })
        });
      }
      return options;
    },
    isFromSollicitation() {
      return (this.$route.params.sollicitation !== undefined && this.$route.params.sollicitation !== null)
    },
    isGardien() {
      // evaluate whatever you need to determine disabled here...
      return this.$store.getters['user/isGardien'];
    },
    partieCommuneSelected() {
      return (this.selectedLogement === null);
    },
    codePec() {
      return this.$store.getters['user/getCodePec'];
    },
    codeTiers() {
      return this.$store.getters['user/getCodeTiers'];
    },
    selectedLogementVacant() {
      if (this.selectedLogement)
        return (this.selectedLogement.idContrat === null)
      else
        return false
    },
    locataireMustBeReclamant() {
      // Indique si un locataire peut être réclamant: il faut qu'un logement soit sélectionné, l'utilisateur ne soit pas gardien et le logement ne soit pas vacant
      return (!this.partieCommuneSelected && !this.isGardien && !this.selectedLogementVacant);
    }
  },
  beforeCreate() {
    if (this.$route.params.motif && this.$route.params.identree) {
      (async () => {
        //La fonction async s'appelle elle même (permet l'usage de await)
        // Cas métier : ouverture de la page de création directement en connaissant le motif et l'entree en params


        const monMotif = this.$route.params.motif

        // ETAPE 1 : A partir du motif récupérer CAT/TYPE/NAT sur l'API (charger de manière asynchrone)
        let donneesMotifCatTypeNatExistent = false;

        this.$store.dispatch('categories/loadCategoriesFromAPI');
        this.$store.dispatch('types/loadTypesFromAPI');
        this.$store.dispatch('natures/loadNaturesFromAPI');
        this.$store.dispatch('motifs/loadMotifsFromAPI');

        const self = this;
        // Une fois que les loads de Categories Types Natures Motifs sont effectué
        // Retrouve la categorie type nature correspondant au motif :
        (function retrieveCategoryTypeNatureFromMotif() {
          if (!(self.$store.getters['categories/categories'] != null && self.$store.getters['types/types'] != null
              && self.$store.getters['natures/natures'] != null && self.$store.getters['motifs/motifs'] != null)) {//we want it to match
            setTimeout(retrieveCategoryTypeNatureFromMotif, 100);//wait 100 millisecnds then recheck
            return;
          }
          //real action
          const motif = self.$store.getters['motifs/getMotifById'](monMotif)
          const nature = self.$store.getters['natures/getNatureById'](motif.nature)
          const type = self.$store.getters['types/getTypeById'](nature?.type)
          const maCategorie = type.categorie

          self.$store.dispatch('categories/setSelectedCategory', maCategorie)
          self.$store.dispatch('types/setSelectedType', nature?.type)
          self.$store.dispatch('natures/setSelectedNature', motif.nature)
          self.$store.dispatch('motifs/setSelectedMotif', monMotif)
          // if ok :
          donneesMotifCatTypeNatExistent = true;
        })();

        // Validation des elements identree et motif partir du motif
        // ETAPE 2 : Vérifier que l'entree existe sur l'API
        const monEntree = this.$route.params.identree
        const monProgramme = monEntree.split("-")[0]

        let entreeExiste = false
        let responseEntree = await this.$store.dispatch('entrees/checkIfEntreeExistAPI', monEntree)
        responseEntree = JSON.parse(responseEntree)

        if ((responseEntree?.length ?? 0) > 0 && responseEntree[0].id) {
          entreeExiste = true
        } else {
          toast.showToast('error', 'Entree non repertoriée...')
        }

        // ETAPE 3 : Charger les données nécessaires au formulaire standalone
        // pour un utilisateur n'ayant pas préchargé les données :

        (function loadDataFormulaireStandalone() {

          if (!(entreeExiste) || !(donneesMotifCatTypeNatExistent) /*Tant que je n'ai pas eu mes validations je recheck*/) {
            setTimeout(loadDataFormulaireStandalone, 100);//wait 100 millisecnds then recheck
            return;
          }
          // Lancement des actions de chargement de données après validations entreeExiste et donneesMotifCatTypeNatExistent :
          self.$store.dispatch('motifs/loadMotifsFromAPI');

          // Dans le cas d'un chargement standalone de la page formulaire attendre que les infos partenaire soient chargées
          // depuis l'API, pour ensuite charger les infos logements :

          self.$store.dispatch('partenaires/loadPartenairesFromAPI', self.$store.getters['user/getCodeTiers']);
          (function loadLogementsAfterPartenaires() {
            if (self.$store.getters['partenaires/partenaires'] == null) {//we want it to match
              setTimeout(loadLogementsAfterPartenaires, 100);//wait 100 millisecnds then recheck
              return;
            }
            //real action
            self.$store.dispatch('logements/loadLogementsFromAPI', self.$store.getters['partenaires/partenaires'])
          })();

          // Chargement des entrées du programme correspondant avant de set le selectedEntree :
          self.$store.dispatch('entrees/loadAllEntreesFromAPI', {programme: monProgramme});
          (function setSelectedEntreeAfterLoadEntrees() {
            if (self.$store.getters['entrees/allEntrees'] == null) {//we want it to match
              setTimeout(setSelectedEntreeAfterLoadEntrees, 100);//wait 100 millisecnds then recheck
              return;
            }
            //real action
            self.$store.dispatch('entrees/setSelectedEntree', monEntree)
          })();

        })(); // FIN loadDataFormulaireStandalone
      })(); // FIN de la fonction async
    } // FIN if (this.$route.params.motif && this.$route.params.identree)

  },
  mounted(){
    this.$store.dispatch('logements/setSelectedLogement', null)
    this.description = this.$route?.query?.commentaire
  }
}
</script>

<style scoped>

form {
  padding-bottom: 20px;
}

.shadow-textarea textarea.form-control::placeholder {
  font-weight: 300;
}

.shadow-textarea textarea.form-control {
  padding-left: 0.8rem;
}

.overview-categorisation p {
  text-transform: capitalize;
}

.vue-js-switch {
  margin-bottom: 0 !important;
}

</style>
